const Staff = {

    "fname": "First Name",
    "lname": "Last Name",
    "username": "Username",
    "status": "Status",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "profile": "Profile Photo",

    "search": "Search",

    "staff": "Staff",

    "error_fname": "Enter First Name",
    "error_username": "Enter Username",
    "error_status": "Select Status",
    "error_password": "Enter Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_pass_match": "Confirm Password doesn't match",
    "error_profile": "Choose Profile Photo",

    "table_uid": "UID",
    "table_name": "NAME",
    "table_username": "USERNAME",
    "table_role": "ROLE",
    "table_status": "STATUS",

}

export default Staff;
